import { useCallback, useState } from 'react';
export const useFocusedState = ({ onFocus, onBlur, }) => {
    const [focused, setFocused] = useState(false);
    const handleOnFocus = useCallback((event) => {
        setFocused(true);
        if (onFocus) {
            onFocus(event);
        }
    }, [onFocus]);
    const handleOnBlur = useCallback((event) => {
        setFocused(false);
        if (onBlur) {
            onBlur(event);
        }
    }, [onBlur]);
    return {
        focused,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
    };
};
//# sourceMappingURL=use-focused-state.js.map